import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useActiveConsultation = (activeConsultationId) => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["activeConsultation", activeConsultationId, tenantVal],
    queryFn: async () => {
      if (!activeConsultationId) return null;

      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/consultation/get/${activeConsultationId}`
      );

      return response.data;
    },
    enabled: !!activeConsultationId && !!tenantVal,
    meta: { errorMessage: "Error fetching consultation" },
  });
};
